import React, { Component } from 'react';
import { Modal, Form, InputNumber, Input, Select } from 'antd';
import { inject, observer } from 'mobx-react/index';
const Option = Select.Option;

@inject('store')
@observer
export class ImportPositionModal extends Component {
    constructor(props) {
        super(props);
        this.form = React.createRef();
    }

    render() {
        return (
            <Modal
                title="Import Position"
                visible={this.props.visible}
                onCancel={() => {
                    this.form.current.resetFields();
                    this.props.onCancel();
                }}
                onOk={() => {
                    this.form.current.validateFieldsAndScroll((err, values) => {
                        if (!err) {
                            this.props.store.botStore.actionStore.execute(
                                'import_position',
                                values
                            );
                            this.form.current.resetFields();
                            this.props.onCancel();
                        }
                    });
                }}
            >
                <CreatePositionForm ref={this.form} />
            </Modal>
        );
    }
}

@inject('store')
@observer
class CreatePositionFormComponent extends Component {
    render() {
        const bot = this.props.store.botStore.currentConfiguration;
        const prices = this.props.store.botStore.marketStore.market;
        const free = this.props.store.botStore.balanceStore.balances.filter(b => {
            if (bot.exchange === 'kraken') {
                return true;
            }
            return b.free > 0;
        });
        let symbols = [];

        Object.keys(prices, free)
            .map(p => prices[p])
            .filter(t => t.symbol.indexOf(bot.base_currency.toUpperCase()) > 3)
            .filter(t => {
                for (let i = 0; i < free.length; i++) {
                    const symbol = free[i];
                    if (t.base === symbol.marketId) {
                        symbols.push({ id: t.name, name: symbol.market.symbol, free: symbol.free });
                    }
                }
                return false;
            });
        const { getFieldDecorator } = this.props.form;

        return (
            <Form>
                <Form.Item label="Symbol" required={true}>
                    {getFieldDecorator('market_id', {
                        rules: [{ required: true, message: 'Field is required' }]
                    })(
                        <Select showSearch>
                            {symbols
                                .sort((a, b) => (a.name > b.name ? 1 : b.name > a.name ? -1 : 0))
                                .map(symbol => (
                                    <Option value={symbol.id} key={symbol.name}>
                                        {symbol.name} -{' '}
                                        {bot.exchange === 'kraken'
                                            ? 'Balance Unavailable'
                                            : symbol.free.toFixed(8)}
                                    </Option>
                                ))}
                        </Select>
                    )}
                </Form.Item>

                <Form.Item label="Amount to import" required={true}>
                    {getFieldDecorator('position_size', {
                        rules: [{ required: true, message: 'Field is required' }]
                    })(<InputNumber style={{ width: '100%' }} min={0} />)}
                </Form.Item>

                <Form.Item label={`Buy Price (${bot.base_currency})`} required={true}>
                    {getFieldDecorator('average_buy_price', {
                        rules: [{ required: true, message: 'Field is required' }]
                    })(<Input type={'number'} style={{ width: '100%' }} precision={8} />)}
                </Form.Item>

                <Form.Item label="Sell Strategy" required={true}>
                    {getFieldDecorator('strategy_id', {
                        rules: [{ required: true, message: 'Field is required' }]
                    })(
                        <Select showSearch style={{ width: '100%' }}>
                            {this.props.store.strategyStore.buySell
                                .slice()
                                .sort((a, b) => {
                                    if (a.name < b.name) return -1;
                                    if (a.name > b.name) return 1;
                                    return 0;
                                })
                                .filter(s => !s.trigger)
                                .map(s => {
                                    return (
                                        <Option value={s.id} key={s.id}>
                                            {s.name}
                                        </Option>
                                    );
                                })}
                        </Select>
                    )}
                </Form.Item>
            </Form>
        );
    }
}

export const CreatePositionForm = Form.create()(CreatePositionFormComponent);



// WEBPACK FOOTER //
// ./src/Account/Bot/PositionsView/ImportPositionModal.js